import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { CiCirclePlus } from "react-icons/ci";

const Navbar = () => {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      const currentUser = auth.currentUser;

      if (currentUser) {
        try {
          const userDoc = await getDoc(doc(db, "users", currentUser.uid));
          if (userDoc.exists()) {
            setUserRole(userDoc.data().role);
          } else {
            console.error("لم يتم العثور على مستند المستخدم");
          }
        } catch (error) {
          console.error("خطأ في جلب دور المستخدم:", error);
        }
      }
      setLoading(false);
    };

    fetchUserRole();
  }, []);

  if (loading) {
    return <div>جاري التحميل...</div>; // عرض مؤشر التحميل أثناء جلب الدور
  }

  return (
    <nav className="flex justify-between items-center">
      <div className="flex space-x-4">
        {userRole === "partner" && (
          <div className="relative group">
            <Link to="/CreateOfferPage" className="text-gray-700 hover:text-gray-900 font-medium mx-4">
              <CiCirclePlus className="text-3xl" />
            </Link>
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full bg-gray-700 text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              إنشاء عرض
            </span>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
